/* eslint-disable no-param-reassign */
import { PayloadAction } from '@reduxjs/toolkit';
import { PermissionsState } from '../permissions.slice';

export default function setSearch(state: PermissionsState, action: PayloadAction<string>): void {
  if (state.tab === 'members') {
    state.membersSearch = action.payload;
  }

  if (state.tab === 'groups') {
    state.groupsSearch = action.payload;
  }
}
